import { array, assign, nullable, number, object, string } from "superstruct";

import { RewardsFreeProductSchema } from "../RewardsFreeProductSchemas/RewardsFreeProductSchema";
import { RewardsFreeProductVariantSchema } from "../RewardsFreeProductSchemas/RewardsFreeProductVariantSchema";

export const RewardsFreeProductRewardSchema = assign(
    RewardsFreeProductSchema,
    object({
        expirationInDays: nullable(number()),
        variants: array(RewardsFreeProductVariantSchema),
    })
);

export const RewardsFreeProductDiscountCodeRewardSchema = assign(
    RewardsFreeProductSchema,
    object({
        discountCode: string(),
        variantId: number(),
        variantTitle: string(),
        variantImage: nullable(string()),
    })
);
